module.exports = __webpack_public_path__ + "008a03d2224d2091f7367723e75e99d6.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/802.png
// module id = 1707
// module chunks = 2